import React, { useMemo } from "react";
import { DonutChart, DonutChartOptions } from "@carbon/charts-react";

// Styles
import "@carbon/charts/styles.css";

// Components
import { Box } from "@mui/material";


interface MacroProgressWheelProps {
  calories: number;
  protein: number;
  fat: number;
  carbs: number;
}

const MacroProgressWheel: React.FC<MacroProgressWheelProps> = ({
  calories,
  protein,
  fat,
  carbs,
}) => {

  // Calculate macro percentages
  const proteinPercent = ((protein * 4) / calories) * 100;
  const carbPercent = ((carbs * 4) / calories) * 100;
  const fatPercent = ((fat * 9) / calories) * 100;
  const isEmpty = calories == 0 || (protein + carbs + fat) == 0;

  const data = useMemo(() => [
    {
      group: "Protein",
      value: proteinPercent,
    },
    {
      group: "Carbs",
      value: carbPercent,
    },
    {
      group: "Fat",
      value: fatPercent,
    },
  ], [proteinPercent, fatPercent, carbPercent]);

  const colorScale = useMemo(() => {
    if (isEmpty) {
      return { empty: 'var(--border-subtle-01)' };
    }
    const colors = [
        'var(--protein)',
        'var(--carbs)',
        'var(--fat)',
    ];

    return data.map(d => d.group).reduce((prev, curr, index) => {
        prev[curr] = colors[index];
        return prev;
    }, ({}) as Record<string, string>);
  }, [data])

  // Define the chart options
  const options: DonutChartOptions = {
    resizable: false,
    animations: false,
    pie: {
        labels: {
            enabled: false
        }
    },
    legend: {
      enabled: false
    },
    toolbar: {
        enabled: false
    },
    tooltip: {
        enabled: false, // Disables tooltips on hover
    },
    color: {
        scale: colorScale
    },
    height: "46px",
    width: "46px"
  };

  return (
      <Box className="MacroProgressWheel" marginRight="4px">
          {!isEmpty ?<DonutChart data={data} options={options} /> :
            <DonutChart data={[{ group: 'empty', value: 1 }]} options={options} />}
      </Box>
  );
};

export default MacroProgressWheel;